import { Cell } from "react-stately";

import type { HTMLAttributes, JSX } from "react";
import type { CellProps } from "react-stately";

export type TableCellProps = CellProps & HTMLAttributes<HTMLTableCellElement>;

export const TableCell = Cell as (props: TableCellProps) => JSX.Element;
